<template>
  <NuxtLayout name="blank">
    <div class="misc-wrapper">
      <ErrorHeader
        :status-code="props.error.statusCode"
        :title="errToShow.title"
        :description="errToShow.description"
      />
      
      <div
        v-if="showDetails"
        class="mt-6"
      >
        <h2 class="font-semibold text-xl">
          Detalles técnicos:
        </h2>
        <pre class="bg-gray-100 p-4 rounded mt-2 text-sm overflow-auto">
          {{ error }}
      </pre>
        <h2 class="font-semibold text-xl">
          Stack:
        </h2>
        <TipTapPrinter
          style="max-inline-size: 80dvw; overflow-x: scroll;"
          :model-value="error.stack"
        />
      </div>
      <VBtn
        class="mb-12"
        @click="handleError"
      >
        {{ $t('Home') }}
      </VBtn>

      <!-- 👉 Image -->
      <div class="misc-avatar w-100 text-center">
        <VImg
          :src="errToShow.img"
          :max-width="200"
          class="mx-auto"
        />
      </div>

      <VImg
        :src="authThemeMask"
        class="misc-footer-img d-none d-md-block"
      />
    </div>
  </NuxtLayout>
</template>

<script setup>
import { reloadNuxtApp } from "#imports"
import { authStore } from "@/store/auth"
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import misc404 from '@images/pages/404.png'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'

const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
})

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)
const { data } = storeToRefs(authStore())
const { toggleDialog } = authStore()

const showDetails = parseInt(data.value.user.USER_PK) === 8


defineOptions({
  inheritAttrs: false,
})

const isDev = process.dev

const errToShow = computed(() => {
  const is404 = props.error?.statusCode === 404 || props.error.message?.includes('404')

  if (is404) {
    return {
      title: useNuxtApp().$i18n.t('error_404_title'),
      description: useNuxtApp().$i18n.t('error_404_description'),
      img: misc404,
    }
  }else{
    toggleDialog('', false) 
    clearNuxtData()
    clearNuxtState()
    localStorage.clear()

    return reloadNuxtApp()

    //clear data an reload app, it has been due to session errors, for other errors it must be changed when it appears xD
  }

/*
  else if (isDev || showDetails) {
  
    // return {
    //   title: props.error?.statusMessage,
    //   description: props.error.message,
    //   img: misc401,
    // }
  }

  return {
    title: useNuxtApp().$i18n.t('error_500_title'),
    description: useNuxtApp().$i18n.t('error_500_description'),
    img: misc500,
  }*/
})

const handleError = () => {
  clearNuxtData()
  clearNuxtState()
  localStorage.clear() 

  clearError({ redirect: '/' })
}
</script>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
